module.exports = __webpack_public_path__ + "img/footer-logo.ac89bb22.svg";